<template lang='pug'>
  r-table( 
    no-actions 
    no-data-text='Sin ventas.'
    no-export
    no-search
    ref='table'
    remind-key='ground-seller-sale-list'
    v-bind='tableProps' 
    )
    template( slot='items' )
      v-btn( 
        color='success'
        :loading='wait'
        @click='submitExcel' 
        ) excel &nbsp;
        v-icon cloud_download
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  //
  import SlGroundSellerSaleService from '@/services/api/Sale/SlGroundSellerSale'
  import SlGroundSellerSaleHeaders from '@/views/Sale/SlGroundSeller/SlGroundSellerSaleHeaders'
  import SlGroundSellerSaleFilters from '@/views/Sale/SlGroundSeller/SlGroundSellerSaleFilters'
  //
  export default {
    components: {
      RTable,
    },
    computed: {
      tableProps() {
        return {
          filters: SlGroundSellerSaleFilters,
          headers: SlGroundSellerSaleHeaders,
          service: SlGroundSellerSaleService,
        }
      },
    },
    data() {
      return {
        wait: false,
      }
    },
    methods: {
      getTableParams() {
        return this
          .$refs
          .table
          .currentParams
      },
      async setWait(value = false) {
        this.wait = value
      },
      submitExcel() {
        return this
          .setWait(true)
          .then(this.getTableParams)
          .then(this.toExcel)
          .then(this.setWait)
      },
      toExcel(params) {
        return SlGroundSellerSaleService
          .shape({ id: 'excel' })
          .fetchExcel(params)
      }
    },
    mounted() {
      this.setTitle('Ventas de vendedores de terreno')
    },
  }
</script>
